
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Divider2","xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"id":"Rectangle_15332","data-name":"Rectangle 15332","width":"30","height":"30","fill":"none"}}),_c('g',{attrs:{"id":"Group_45615","data-name":"Group 45615"}},[_c('g',{attrs:{"id":"Group_45617","data-name":"Group 45617","fill":"#5251f8"}},[_c('path',{attrs:{"id":"Path_32791","data-name":"Path 32791","d":"M18.581 9.523a.744.744 0 01-.53-.22L15 6.252 11.949 9.3a.75.75 0 01-1.06-1.06l3.581-3.578a.749.749 0 011.06 0l3.581 3.581a.75.75 0 01-.53 1.28"}}),_c('path',{attrs:{"id":"Path_32792","data-name":"Path 32792","d":"M15 25.558a.744.744 0 01-.53-.22l-3.581-3.581a.75.75 0 011.06-1.06L15 23.747l3.051-3.05a.75.75 0 011.06 1.06l-3.581 3.581a.744.744 0 01-.53.22"}}),_c('path',{attrs:{"id":"Path_32793","data-name":"Path 32793","d":"M22.5 15.75h-15a.75.75 0 010-1.5h15a.75.75 0 010 1.5"}})])])])
          )
        }
      }
    